
import React from 'react';

interface PricingToggleProps {
  isYearly: boolean;
  setIsYearly: (isYearly: boolean) => void;
}

export const PricingToggle = ({ isYearly, setIsYearly }: PricingToggleProps) => {
  return (
    <div className="flex items-center justify-center mt-8">
      <span className={`mr-3 text-sm font-medium ${!isYearly ? 'text-gray-900' : 'text-gray-500'}`}>
        Mensuel
      </span>
      <button
        onClick={() => setIsYearly(!isYearly)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-socialsync-500 focus:ring-offset-2 ${
          isYearly ? 'bg-socialsync-600' : 'bg-gray-300'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isYearly ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className={`ml-3 text-sm font-medium ${isYearly ? 'text-gray-900' : 'text-gray-500'}`}>
        Annuel <span className="text-green-600 font-medium">(Économisez 15%)</span>
      </span>
    </div>
  );
};
